import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StaticFieldState } from './static-field.reducer';

export const staticFieldStateFeatureSelector = createFeatureSelector('staticField');

export const getStaticField = createSelector(
    staticFieldStateFeatureSelector,
    (state: StaticFieldState) => state?.fields
);
